export default __webpack_public_path__ + "static/media/nextjs.a9833252.svg";